"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var EventBindingBonusEditor = /** @class */ (function (_super) {
    __extends(EventBindingBonusEditor, _super);
    function EventBindingBonusEditor(props) {
        return _super.call(this, props) || this;
    }
    EventBindingBonusEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    bonus_template_id: _item.bonus_template_id,
                    bonus_template_title: _item.bonus_template_title,
                    is_greater_or_eq_min_dep_amt_only: _item.is_greater_or_eq_min_dep_amt_only,
                    min_deposit_amount: _item.min_deposit_amount,
                    is_lower_max_dep_amt_only: _item.is_lower_max_dep_amt_only,
                    max_deposit_amount: _item.max_deposit_amount,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    _bonus_templates: []
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактор бонуса события"]);
                });
            }
        }
        else {
            this.setState({
                bonus_template_id: 0,
                bonus_template_title: "",
                is_greater_or_eq_min_dep_amt_only: false,
                min_deposit_amount: 1,
                is_lower_max_dep_amt_only: false,
                max_deposit_amount: 10,
                description: "",
                is_locked: false,
                _bonus_templates: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание события"]);
            });
        }
        this.SID_LBT = this.props.listBonusTemplates.Subscribe("*", function (id, data) {
            _this.setState({
                _bonus_templates: data.data
            });
        });
        this.props.listBonusTemplates.LoadData(this.props.rootRecord.brand_id, this.props.rootRecord.event_type_code);
        this.doReSetRules();
    };
    EventBindingBonusEditor.prototype.componentWillUnmount = function () {
        this.props.listBonusTemplates.UnSubscribe(this.SID_LBT);
    };
    EventBindingBonusEditor.prototype.doReSetRules = function () {
        this.setState({
            bonus_template_rules: { isError: false },
            min_deposit_amount_rules: { isError: false },
            max_deposit_amount_rules: { isError: false }
        });
    };
    EventBindingBonusEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.bonus_template_id <= 0) || (this.state.bonus_template_title.length === 0)) {
            this.setState({ bonus_template_rules: { isError: true, errorMessage: "Поле [Шаблон бонуса] не выбрано!" } });
            return false;
        }
        if (this.state.is_greater_or_eq_min_dep_amt_only) {
            if (this.state.min_deposit_amount <= 0) {
                this.setState({ min_deposit_amount_rules: { isError: true, errorMessage: "Минимальная сумма указана некорректно!" } });
                return false;
            }
        }
        if (this.state.is_lower_max_dep_amt_only) {
            if (this.state.max_deposit_amount <= 0) {
                this.setState({ max_deposit_amount_rules: { isError: true, errorMessage: "Максимальная сумма указана некорректно!" } });
                return false;
            }
        }
        if ((this.state.is_greater_or_eq_min_dep_amt_only) && (this.state.is_lower_max_dep_amt_only)) {
            if (this.state.min_deposit_amount >= this.state.max_deposit_amount) {
                this.setState({ max_deposit_amount_rules: { isError: true, errorMessage: "Максимальная сумма меньше минимальной!" } });
                this.setState({ min_deposit_amount_rules: { isError: true, errorMessage: "Минимальная сумма больше минимальной!" } });
                return false;
            }
        }
        return true;
    };
    EventBindingBonusEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                bonus_template_id: this.state.bonus_template_id,
                is_greater_or_eq_min_dep_amt_only: this.state.is_greater_or_eq_min_dep_amt_only,
                min_deposit_amount: this.state.min_deposit_amount,
                is_lower_max_dep_amt_only: this.state.is_lower_max_dep_amt_only,
                max_deposit_amount: this.state.max_deposit_amount,
                is_locked: this.state.is_locked,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бонус обработчика события изменен!");
            });
        }
    };
    EventBindingBonusEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                event_binding_id: this.props.rootRecord.key,
                bonus_template_id: this.state.bonus_template_id,
                is_greater_or_eq_min_dep_amt_only: this.state.is_greater_or_eq_min_dep_amt_only,
                min_deposit_amount: this.state.min_deposit_amount,
                is_lower_max_dep_amt_only: this.state.is_lower_max_dep_amt_only,
                max_deposit_amount: this.state.max_deposit_amount,
                is_locked: this.state.is_locked,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бонус обработчика события добавлен!");
            });
        }
    };
    EventBindingBonusEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    EventBindingBonusEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить бонус обработчика события";
        }
        else {
            return "Изменить бонус обработчика события";
        }
    };
    EventBindingBonusEditor.prototype.getRenderObjectWithAmount = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 540 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите шаблон бонуса:", placeholder: "Выберите шаблон бонуса" }, value: { key: this.state.bonus_template_id, value: this.state.bonus_template_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_template_id: newVal.key,
                        bonus_template_title: newVal.value,
                        bonus_template_rules: { isError: false }
                    });
                }, items: this.state._bonus_templates, required: true, rules: this.state.bonus_template_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Больше или равно минимальной суммы", value: this.state.is_greater_or_eq_min_dep_amt_only, onChecked: function (checked) { _this.setState({ is_greater_or_eq_min_dep_amt_only: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430:",
                    placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443:"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.min_deposit_amount
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_deposit_amount: newVal,
                        min_deposit_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.min_deposit_amount_rules, disabled: !this.state.is_greater_or_eq_min_dep_amt_only }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Меньше максимальной суммы", value: this.state.is_lower_max_dep_amt_only, onChecked: function (checked) { _this.setState({ is_lower_max_dep_amt_only: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430:",
                    placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443:"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.max_deposit_amount
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_deposit_amount: newVal,
                        max_deposit_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.max_deposit_amount_rules, disabled: !this.state.is_lower_max_dep_amt_only }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус обработчика события заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    EventBindingBonusEditor.prototype.getRenderObjectWithoutAmount = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите шаблон бонуса:", placeholder: "Выберите шаблон бонуса" }, value: { key: this.state.bonus_template_id, value: this.state.bonus_template_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_template_id: newVal.key,
                        bonus_template_title: newVal.value,
                        bonus_template_rules: { isError: false }
                    });
                }, items: this.state._bonus_templates, required: true, rules: this.state.bonus_template_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус обработчика события заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    EventBindingBonusEditor.prototype.getRenderObject = function () {
        if (this.props.rootRecord.is_need_amount) {
            return this.getRenderObjectWithAmount();
        }
        else {
            return this.getRenderObjectWithoutAmount();
        }
    };
    EventBindingBonusEditor.prototype.render = function () {
        return (this.getRenderObject());
    };
    return EventBindingBonusEditor;
}(React.Component));
exports.default = EventBindingBonusEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/EventBindingBonusEditor.tsx
// module id = 1981
// module chunks = 0